import { mergeStyles } from "@react-spectrum/s2";

import VideoIcon from "@react-spectrum/s2/icons/Video";
import AfterEffectsIcon from "icon:@app/assets/S2_AeSolid.svg";
import FigmaIcon from "icon:@app/assets/S2_Figma.svg";
import ExpressIcon from "icon:@app/assets/S2_AdobeExpressSolid.svg";

import {
  style,
  iconStyle,
  size,
  lightDark,
} from "@react-spectrum/s2/style" with { type: "macro" };

const iconStyles = style({
  "--iconPrimary": {
    type: "fill",
    value: "currentColor",
  },
  display: "block",
  size: {
    size: {
      S: 14,
      M: 18,
      L: 20,
      XL: 24,
    },
  },
});

export const TemplateIcon = ({ type, size = "M", styles }) => {
  if (["figma", "html"].includes(type?.toLowerCase())) {
    return <FigmaIcon styles={mergeStyles(iconStyles({ size }), styles)} />;
  } else {
    return <VideoIcon styles={mergeStyles(iconStyles({ size }), styles)} />;
  }
};
